import { render, staticRenderFns } from "./seting.vue?vue&type=template&id=7490b965&scoped=true&"
import script from "./seting.vue?vue&type=script&lang=js&"
export * from "./seting.vue?vue&type=script&lang=js&"
import style0 from "./seting.vue?vue&type=style&index=0&id=7490b965&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490b965",
  null
  
)

export default component.exports